// shared/application/optimizarImagen.js  (paso de compresión del pipeline de agregado). Sin JSX ni Swal.
import { compresorImagen } from '../infrastructure/compresorImagen';
import { MAX_IMAGE_BYTES, MOTIVO_PROCESAMIENTO } from '../domain/media';

/**
 * Comprime un archivo. Si la compresión falla se usa el original solo si cabe en MAX_IMAGE_BYTES.
 * Devuelve { file } o { rechazada: { name, reason: 'procesamiento' } }. `compresor` inyectable ({ comprimir(file) }).
 */
export const optimizarImagen = async (file, compresor = compresorImagen) => {
  try {
    const { file: resultado } = await compresor.comprimir(file);
    return { file: resultado };
  } catch (e) {
    if (file.size <= MAX_IMAGE_BYTES) return { file };
    return { rechazada: { name: file.name, reason: MOTIVO_PROCESAMIENTO } };
  }
};
